// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  orderId: __t.u64().primaryKey().name("order_id"),
  settlementId: __t.u64().name("settlement_id"),
  commodity: __t.string(),
  qty: __t.f32(),
  premiumBps: __t.i32().name("premium_bps"),
  postedAt: __t.timestamp().name("posted_at"),
  expiresAt: __t.timestamp().name("expires_at"),
});
